import { render, staticRenderFns } from "./AutocompleteAgency.vue?vue&type=template&id=2303ecaa&scoped=true&"
import script from "./AutocompleteAgency.vue?vue&type=script&lang=js&"
export * from "./AutocompleteAgency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2303ecaa",
  null
  
)

export default component.exports
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QItem,QItemSection,QItemLabel});qInstall(component, 'directives', {Ripple});
